<div class="row cfa-toolbar-height">
    <div #tabEl *ngFor="let tab of cfaTabs; let i = index;"
         class="col-auto clicky cfa-toolbar-height cfa-nav-tab"
         [class.disabled]="tab.disabled"
         (click)="clickTab($event, tab, true)" id="tab{{i}}">
        <div class="row justify-content-center cfa-toolbar-height cfa-toolbar-tab"
             [class.active]="tab.active">
            <div class="col cfa-15 cfa-toolbar-tab-label text-center align-self-center"
                 [class.text-center]="!tab.childTabs || tab.childTabs.length === 0">
                <div class="activeChildParentTabName" *ngIf="getActiveChildTab(tab)"
                     [@slideUpState]="'active'">
                    {{tab.label}}
                </div>
                {{getActiveTabName(tab)}}
            </div>
            <div class="col-auto cfa-15 align-self-center text-center pl-1 pr-0" *ngIf="tab.childTabs && tab.childTabs.length > 0" >
                <svg-icon class="cfa-tab-icon"src="https://d4gii57lvoht3.cloudfront.net/images/Arrow_Down.svg"></svg-icon>
            </div>
        </div>
        <div class="child-tab-container"
             [@openOverlayState]="'active'" *ngIf="tab.childTabs && tab.childTabs.length > 0 && tab.expanded"
             [class.mat-app-background]="useMaterialTheme"
             [class.cfaCustomLightTheme]="!useMaterialTheme">
            <ng-container *ngFor="let cTab of tab.childTabs; let j = index; let last = last;">
                <div class="row cfa-child-nav-tab cfa-toolbar-height"
                     [class.active]="cTab.active"
                     [class.disabled]="tab.disabled || cTab.disabled"
                     (click)="clickTab($event, cTab)" id="cTab{{j}}">
                    <div class="col-12 align-self-center cfa-15 text-center">
                        {{cTab.label}}
                    </div>
                </div>
                <hr class="child-tab-separator" *ngIf="!last">
            </ng-container>
        </div>
    </div>
</div>
